import { parse, format } from 'libphonenumber-js';

export const parseAndFormat = (countryCode, phoneNumber) => {
  if (!countryCode || !phoneNumber) return undefined;
  countryCode = countryCode.startsWith('+') ? '' + countryCode : '+' + countryCode;
  const formatted = format(parse(countryCode + phoneNumber), 'International');
  const unformatted = countryCode + ' ' + phoneNumber;
  return formatted ? formatted : unformatted;
};
